// Google Consent Mode v2. El 'consent default' (todo denied) va inline al principio del <head>
// (nuxt.config.js, app.head.script). Aquí se manda el 'update' cuando el usuario acepta o rechaza
// la cookie de Analytics, y gtag.js solo se carga tras aceptar. Ref: https://trello.com/c/X9e65E4p
export function useConsentimientoGoogle() {
  const { gtag, initialize, enableAnalytics, disableAnalytics } = useGtag()

  function actualizar(estado: 'granted' | 'denied') {
    gtag('consent', 'update', {
      ad_user_data: estado,
      ad_personalization: estado,
      ad_storage: estado,
      analytics_storage: estado
    })
  }

  // El 'update' va antes de cargar gtag.js para que la primera visita ya salga con consentimiento.
  // nuxt-gtag no manda 'js' ni 'config' si window.dataLayer ya existe (lo crea el script del <head>),
  // así que se mandan aquí la primera vez.
  function aceptar(gaId?: string) {
    actualizar('granted')
    if (!gaId || !import.meta.client) return
    if (!document.head.querySelector('script[data-gtag]')) {
      gtag('js', new Date())
      gtag('config', gaId)
    }
    initialize(gaId)
    enableAnalytics(gaId)
  }

  function rechazar(gaId?: string) {
    actualizar('denied')
    if (gaId) disableAnalytics(gaId)
  }

  return { aceptar, rechazar }
}
